export default {
    RELOAD_ONTOLOGY: "Обновить онтологическую модель",
    TESTING: "Тестировать",
    URL_PLACEHOLDER: "Введите URL",
    LOGIN_PLACEHOLDER: "Введите логин",
    API_KEY_PLACEHOLDER: "Введите API-key",
    PASSWORD_PLACEHOLDER: "Введите пароль",
    LOGIN: "Логин",
    URL: "URL",
    API_KEY: "API-key",
    PASSWORD: "Пароль"
};
